<div class="pagination-shell d-flex align-items-center justify-content-between flex-wrap gap-2">
  <div class="d-flex align-items-center gap-2">
    <span class="text-muted small">Rows per page</span>

    <select
      class="form-select form-select-sm w-auto"
      [disabled]="loading"
      [ngModel]="perPage"
      (ngModelChange)="onPerPageChange($event)"
    >
      <option
        *ngFor="let option of perPageOptions"
        [ngValue]="option"
      >
        {{ option }}
      </option>
    </select>
  </div>

  <p class="m-0 text-muted small" *ngIf="hasRecords">
    Showing
    <span>{{ showingFrom }}</span>
    to
    <span>{{ showingTo }}</span>
    of
    <span>{{ total }}</span>
    records
  </p>

  <p class="m-0 text-muted small" *ngIf="!hasRecords">
    Showing 0 records
  </p>

  <ul class="pagination m-0">
    <li class="page-item" [class.disabled]="!canGoPrevious">
      <button
        type="button"
        class="page-link"
        [disabled]="!canGoPrevious"
        (click)="previousPage()"
        aria-label="Previous page"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M15 6l-6 6l6 6" />
        </svg>
      </button>
    </li>

    <li
      class="page-item"
      *ngFor="let item of pageItems; trackBy: trackByPaginationItem"
      [class.active]="item.type === 'page' && item.active"
      [class.disabled]="item.type === 'ellipsis'"
    >
      <button
        *ngIf="item.type === 'page'"
        type="button"
        class="page-link"
        [disabled]="loading || item.active"
        (click)="goToPage(item.page)"
      >
        {{ item.page }}
      </button>

      <span
        *ngIf="item.type === 'ellipsis'"
        class="page-link"
      >
        …
      </span>
    </li>

    <li class="page-item" [class.disabled]="!canGoNext">
      <button
        type="button"
        class="page-link"
        [disabled]="!canGoNext"
        (click)="nextPage()"
        aria-label="Next page"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 6l6 6l-6 6" />
        </svg>
      </button>
    </li>
  </ul>
</div>